// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HealthStatus_wrapper__3QvFm"};